import React, { useMemo, useRef } from 'react'
import SetupTab from 'modules/setup/setupTab/SetupTab'
import {
	TextBox, Label, RemoveModal, TextArea, CarcasaCombo, EmbalajeCombo,
	ProteccionCombo, PotenciaCombo, RotacionSincronicaCombo, VoltajeCombo, TipoProductoCombo,
	FileUpload, CheckBox
} from 'components'
import { Row, Col, FormGroup } from 'react-bootstrap'
import { fetchUrl } from 'modules/util/functions'
import { useSetupTabValueContext, useSetupTabActionsContext } from 'modules/setup/setupTab/SetupTabContext'

const ProductoInfoTab = () => {
	const { selectedId, form } = useSetupTabValueContext();
	const { onDelete, onError, onSuccess } = useSetupTabActionsContext();
	const _removeModal = useRef();

	const configuration = useMemo(() => ({
		urls: {
			get: "/productoSetup/getProductoInfo",
			save: "/productoSetup/saveProductoInfo",
			create: "/productoSetup/createProducto"
		},
		getRequest: () => {
			return {
				idProducto: selectedId
			}
		},
		saveRequest: (form) => {
			return {
				idProducto: selectedId,
				nombre: form.nombre,
				descripcion: form.descripcion,
				idTipoProducto: form.idTipoProducto,
				idCarcasa: form.idCarcasa,
				idEmbalaje: form.idEmbalaje,
				idProteccion: form.idProteccion,
				idPotencia: form.idPotencia,
				idRotacionSincronica: form.idRotacionSincronica,
				idVoltaje: form.idVoltaje,
				urlImagen: form.urlImagen,
				destacado: form.destacado
			}
		}
	}), [selectedId]);

	const actions = [{
		key: "delete",
		name: "Borrar",
		onClick: () => {
			handleDelete();
		}
	}];

	// Handlers
	const handleDelete = () => {
		const rq = {
			idProducto: selectedId
		};

		_removeModal.current.open({
			title: "Eliminando producto",
			name: form.nombre,
			onYes: () => {
				fetchUrl("/productoSetup/deleteProducto", "post", rq, {
					success: (r) => {
						onSuccess(r.message);
						onDelete();
					},
					error: (r) => {
						onError(r.errorMessage);
					}
				}, { block: false });
			}
		});
	}

	return (
		<React.Fragment>
			<RemoveModal
				ref={_removeModal} />

			<SetupTab
				configuration={configuration}
				actions={actions}>
				<Row>
					<Col md={4}>
						<FormGroup>
							<Label required>Nombre</Label>
							<TextBox
								name="nombre"
								placeholder="Nombre" />
						</FormGroup>
						<FormGroup style={{ marginTop: "20px" }}>
							<Label>Carcasa</Label>
							<CarcasaCombo
								name="idCarcasa"
								placeholder="Carcasa" />
						</FormGroup>
						<FormGroup style={{ marginTop: "20px" }}>
							<Label>Embalaje</Label>
							<EmbalajeCombo
								name="idEmbalaje"
								placeholder="Embalaje" />
						</FormGroup>
						<FormGroup style={{ marginTop: "20px" }}>
							<Label>Proteccion</Label>
							<ProteccionCombo
								name="idProteccion"
								placeholder="Proteccion" />
						</FormGroup>
						<FormGroup style={{ marginTop: "20px" }}>
							<Label>Potencia</Label>
							<PotenciaCombo
								name="idPotencia"
								placeholder="Potencia" />
						</FormGroup>
						<FormGroup style={{ marginTop: "20px" }}>
							<Label>Rotacion Sincronica</Label>
							<RotacionSincronicaCombo
								name="idRotacionSincronica"
								placeholder="Rotacion Sincronica" />
						</FormGroup>
						<FormGroup style={{ marginTop: "20px" }}>
							<Label>Voltaje</Label>
							<VoltajeCombo
								name="idVoltaje"
								placeholder="Voltaje" />
						</FormGroup>
						<FormGroup style={{ marginTop: "20px" }}>
							<Label>Destacado</Label>
							<CheckBox
								type="switch"
								name="destacado" />
						</FormGroup>
					</Col>
					<Col md={4}>
						<FormGroup>
							<Label>Tipo de Producto</Label>
							<TipoProductoCombo
								name="idTipoProducto"
								placeholder="Tipo de Producto" />
						</FormGroup>
						<FormGroup style={{ marginTop: "20px" }}>
							<Label>Descripcion</Label>
							<TextArea
								name="descripcion"
								placeholder="Descripcion"
								rows={4} />
						</FormGroup>
						<FormGroup style={{ marginTop: "20px" }}>
							<Label>Imagen</Label>
							<FileUpload
								name="urlImagen"
								placeholder="Imagen" />
						</FormGroup>
					</Col>
				</Row>
			</SetupTab>
		</React.Fragment>
	)
}

export default ProductoInfoTab;